import { LinkChildren, ButtonLink } from "../components/button";
import { Image } from "../components/media";

import { logingOut } from "../actions/authActions";

function ClientSidebar() {
  return (
    <div className="leftbar">
      <div className="sidebar">
        <div className="logobar">
          <LinkChildren href="/dashboard" extraClass="logo logo-large">
            <Image src="logo.png" />
          </LinkChildren>
          <LinkChildren href="/dashboard" extraClass="logo logo-small">
            <Image src="logo.png" />
          </LinkChildren>
        </div>
        <div className="navigationbar">
          <ul className="vertical-menu">
            <li>
              <a href="#!">
                <Image src="svg-icon/ecommerce.svg" />
                <span>Ingreso de compra</span>
                <i className="feather icon-chevron-right pull-right"></i>
              </a>
              <ul className="vertical-submenu">
                <li>
                  <ButtonLink
                    href="/dashboard/articulos/nuevo"
                    text="Nuevo"
                    extraClass="menu-link"
                  />
                </li>
                <li>
                  <ButtonLink
                    href="/dashboard/articulos"
                    text="Todos"
                    extraClass="menu-link"
                  />
                </li>
              </ul>
            </li>
            <li>
              <a href="#!">
                <Image src="svg-icon/dashboard.svg" />
                <span>Paquetes</span>
                <i className="feather icon-chevron-right pull-right"></i>
              </a>
              <ul className="vertical-submenu">
                <li>
                  <ButtonLink
                    href="/dashboard/paquetes/nuevo"
                    text="Nuevo"
                    extraClass="menu-link"
                  />
                </li>
                <li>
                  <ButtonLink
                    href="/dashboard/paquetes"
                    text="Activos"
                    extraClass="menu-link"
                  />
                </li>
                <li>
                  <ButtonLink
                    href="/dashboard/paquetes/archivados"
                    text="Archivados"
                    extraClass="menu-link"
                  />
                </li>
              </ul>
            </li>

            <li>
              <a href="#!">
                <Image src="svg-icon/user.svg" />
                <span>Cuenta</span>
                <i className="feather icon-chevron-right pull-right"></i>
              </a>
              <ul className="vertical-submenu">
                <li>
                  <ButtonLink
                    href="/dashboard/account"
                    text="Perfil"
                    extraClass="menu-link"
                  />
                </li>
                <li>
                  <ButtonLink
                    href="/dashboard/account/notificaciones"
                    text="Notificaciones"
                    extraClass="menu-link"
                  />
                </li>
                <li>
                  <a
                    href="#!"
                    onClick={() => {
                      logingOut();
                    }}
                  >
                    Cerrar sesi&oacute;n
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ClientSidebar;
